import React, { useEffect, useState } from "react";
import ApexCharts from "react-apexcharts";

const SplineAreaChart = ({ data, categories, from }) => {
  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      animations: { enabled: true },
      zoom: { enabled: false },
    },
    stroke: { curve: "smooth", width: 3 },
    colors: ["#007bff", "#00e600", "#ffcc00"],
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.6,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    dataLabels: { enabled: true },
    xaxis: {
      categories,
      labels: { style: { fontSize: "12px" }, rotate: -45, offsetY: -10 },
    },
    yaxis: {
      labels: { show: false, style: { fontSize: "10px" } },
    },
    grid: {
      borderColor: "#e7e7e7",
      strokeDashArray: 5,
      padding: { left: 10, right: 5, top: -20, bottom: -30 },
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      fontSize: "10px",
      fontWeight: "bold",
      show: from !== "Punctuality",
      labels: {
        colors: "#000",
        style: { fontSize: "10px", fontWeight: "bold" },
      },
    },
    tooltip: { style: { fontSize: "11px" } },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 200,
          },
        },
      },
    ],
  };

  return (
    <div
      className="d-flex justify-content-center w-100 border"
      style={{
        padding: "0px",
        margin: "0px",
      }}
    >
      <div className="w-100" style={{ maxWidth: "1200px" }}>
        <ApexCharts
          options={chartOptions}
          series={data}
          type="area"
          height="100"
        />
      </div>
    </div>
  );
};

export default SplineAreaChart;
